import React from 'react';
import { Route, BrowserRouter, Switch } from 'react-router-dom';

import Home from './pages/Home';
import Command from './pages/Command';
import TeamPage from './pages/Team';

function Router () {
    return (
        <BrowserRouter>
            <Switch>
                <Route exact="/"  path="/" component={Home} />
                <Route path="/commands" component={Command} />
                <Route path="/team" component={TeamPage} />
            </Switch>
        </BrowserRouter>
    )
}

export default Router;